import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';

const NotificationSummary = ({ unreadCount, releasesThisMonthCount, announcementCount, systemAlertCount }) => {
    const tiles = [
        { label: 'Unread', value: unreadCount, color: '#6252c7', tint: '#ece9fb' },
        { label: 'Releases this month', value: releasesThisMonthCount, color: '#16866f', tint: '#e6f7f1' },
        { label: 'Announcements', value: announcementCount, color: '#d98b12', tint: '#fff3e8' },
        { label: 'System alerts', value: systemAlertCount, color: '#d32f2f', tint: '#fdecea' }
    ];

    return (
        <Box className="notification-page-summary-card">
            <Typography className="notification-page-panel-title">Notification summary</Typography>
            <Grid container spacing={1}>
                {tiles.map(tile => (
                    <Grid key={tile.label} item xs={12} sm={6} lg={12} xl={6} style={{ minWidth: 0 }}>
                        <Box className="notification-page-summary-tile" style={{ '--tile-color': tile.color, '--tile-tint': tile.tint }}>
                            <Typography className="notification-page-summary-value">{tile.value}</Typography>
                            <Typography className="notification-page-summary-label">{tile.label}</Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default NotificationSummary;
